/**
 * Come si nomina una riga in schermata: l'ordine, o la bolla quando l'ordine
 * non c'è.
 *
 * Una funzione sola perché i posti che lo scrivono sono quattro — l'elenco delle
 * righe, la ricerca per articolo, la barra dell'agganciata e la zona d'azione —
 * e quattro copie della stessa frase divergono al primo ritocco. Il costo di
 * sbagliarla è che l'operatrice legge `MAG-552781` come se fosse un numero
 * d'ordine e lo va a cercare su DecoNetwork, dove non esiste.
 *
 * `LineView.ordine` porta infatti la **chiave interna** del banco, che per la
 * merce a scorta è la bolla prefissata: è ciò che tiene distinte due righe dello
 * stesso articolo, non un numero da mostrare.
 */

import type { LineView } from '@errebi/domain';

/** Quel che si scrive dove le righe d'ordine scrivono «ordine 606913». */
export function nomeRiga(r: Pick<LineView, 'ordine' | 'aMagazzino' | 'acquisto'>): string {
  return r.aMagazzino ? `a magazzino · bolla ${r.acquisto}` : `ordine ${r.ordine}`;
}

/** Chi aspetta la merce: un cliente, oppure il magazzino. */
export function nomeDestinatario(r: Pick<LineView, 'cliente' | 'aMagazzino'>): string {
  return r.aMagazzino ? 'Magazzino' : r.cliente;
}

/** The warning an express line carries: no crate, loose into Modula express. */
export function avvisoExpress(r: Pick<LineView, 'express'>): string | null {
  return r.express ? 'Merce express: va sfusa nel Modula express, non in cassetta.' : null;
}
